<template>
  <SearchContainer @search="search">
    <template slot="default">
      <div class="row">
        <div class="col-12 col-sm-4 mb-3">
          <Input
            type="dropdown"
            :label="$t('sections.alarmSettings.search.module')"
            :items="$t('modules')"
            button
            :field="query.module"
            @input="(e) => onInput('module', e)"
            @onClick="search"
          />
        </div>
      </div>
    </template>
  </SearchContainer>
</template>

<script>
import SearchContainer from '@/components/sections/common/SearchContainer.vue';
import Input from '@/components/ui/Input.vue';

export default {
  name: 'AlarmSettingsSearchOptions',
  components: {
    SearchContainer,
    Input,
  },
  data() {
    return {
      query: {
        module: '',
      },
    };
  },
  methods: {
    onInput(field, value) {
      this.query[field] = value;
    },
    search() {
      this.$emit('onSearch', this.query);
    },
  },
};
</script>
<style lang="scss" scoped></style>
